import { Button, Tooltip, Typography } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '../../../../../../../i18n/useTranslation';
import { useRefetch, useRouteToTab } from '../../../../EntityContext';
import { EMPTY_MESSAGES } from '../../../../constants';
import { AddLinkModal } from '../../../../components/styled/AddLinkModal';

const EmptyContentWrapper = styled.div`
    margin-bottom: 5px;
    font-size: 14px;
`;

const EmptyContentMessage = styled(Typography.Paragraph)`
    font-size: 14px;
`;

const AddLinkWrapper = styled.span<{ isReadOnly?: boolean }>`
    display: inline-block;
    cursor: ${(props) => (props.isReadOnly ? 'not-allowed' : 'pointer')};
`;

interface Props {
    hideLinksButton?: boolean;
    hasLinks?: boolean;
    readOnly?: boolean;
}

export default function EmptyContentSection({ hideLinksButton, readOnly, hasLinks }: Props) {
    const routeToTab = useRouteToTab();
    const refetch = useRefetch();
    const { t } = useTranslation();

    return (
        <EmptyContentWrapper>
            <>
                <EmptyContentMessage type="secondary">
                    {t(EMPTY_MESSAGES.documentation.title)}. {t(EMPTY_MESSAGES.documentation.description)}
                </EmptyContentMessage>
                <Tooltip title={readOnly ? t('ASSET_MARKED_AS_READ_ONLY') : undefined}>
                    <Button
                        className="mb-2 mr-2"
                        onClick={() => routeToTab({ tabName: t('Documentation'), tabParams: { editing: true } })}
                        aria-label={t('Add Documentation')}
                        disabled={readOnly}
                    >
                        <EditOutlined aria-hidden="true" /> {t('Add Documentation')}
                    </Button>
                </Tooltip>
                {!hideLinksButton && hasLinks && (
                    <Tooltip title={readOnly ? t('ASSET_MARKED_AS_READ_ONLY') : undefined}>
                        <AddLinkWrapper isReadOnly={readOnly}>
                            <AddLinkModal refetch={refetch} buttonProps={{ disabled: readOnly }} />
                        </AddLinkWrapper>
                    </Tooltip>
                )}
            </>
        </EmptyContentWrapper>
    );
}
